import yup from 'utils/yup';

export const initialHolidayData = {
  id: '',
  name: '',
  uuid: '' as any,
  start_date: null as any,
  end_date: null as any,
  active: true,
  users: [] as Array<any>,
  group_ids: [],
  on_calendar: false as boolean,
  repeat_yearly: false as boolean,
};

export const holidayFormValidationSchema = yup.object().shape({
  name: yup.string().required(),
  start_date: yup.date().required({ msg: 'This is required' }).typeError({ msg: 'This must be a valid date' }),
  end_date: yup
    .date()
    .required({ msg: 'This is required' })
    .typeError({ msg: 'This must be a valid date' })
    .min(yup.ref('start_date'), { msg: 'End date cannot be before start date' }),
});
